import React from 'react';

const SectionDivider: React.FC = () => {
  return (
    <div className="py-10 section-divider-container">
      <div className="section-divider"></div>
    </div>
  );
};

export default SectionDivider;